<template>
  <b-breadcrumb>
    <b-breadcrumb-item v-for="(obj, index) in items"
                       :to="obj.to"
                       :active="items.length > 1 && !obj.to"
                       :key="`breadcrumb_${index}_${obj.text}`">
      <font-awesome-icon v-if="obj.icon" :icon="obj.icon"/>
      {{obj.text | striptags}}
    </b-breadcrumb-item>
  </b-breadcrumb>
</template>

<script>
  export default {
    name: "ArtisioBreadcrumb",
    props: {
      items: {
        type: Array,
        required: true
      }
    }
  }
</script>

<style scoped>
  .breadcrumb {
    background-color: rgb(255, 255, 255) !important;
    margin-bottom: 0;
    padding: 0;
  }
</style>
